import React, { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { Navigate } from "react-router-dom";
import LoadingPage from "../salon/desktop/loading/index";

// 学校管理画面(/school/service/*)のログイン確認。
// 学校も /company/login からログインする(1-login.tsx の schoolLogin)ため、
// 未ログインならそこへ戻す。以前はこの確認が無く、未ログインで開くと
// データが読めないまま空の管理画面が表示されていた。
const SchoolAuthGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [authState, setAuthState] = useState<"loading" | "ok" | "ng">("loading");

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(getAuth(), (user) => {
      setAuthState(user ? "ok" : "ng");
    });
    return () => unsubscribe();
  }, []);

  if (authState === "loading") {
    return <LoadingPage />;
  }

  if (authState === "ng") {
    return <Navigate to="/company/login" replace />;
  }

  return <>{children}</>;
};

export default SchoolAuthGate;
